import { FC, SVGProps } from 'react'

export const Filter: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2 4H21.6442L14.2084 12.5973V20.3515L9.43572 18.0182V12.5973L2 4ZM5.28052 5.5L10.9357 12.0387V17.0818L12.7084 17.9485V12.0387L18.3636 5.5H5.28052Z"
			fill="currentColor"
		/>
	</svg>
)
